define.alias("checkout/components/payment/payment-method/index", "calendar/components/payment/payment-method/index");